export function isPhone() {
    return !!navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|HMSCore|GMSCore)/i)
}

export function isIOS(){
    return !!navigator.userAgent.match(/(iPhone|iPod|ios|iPad)/i)
}